<template>
  <BLayout align-center>
    <button
      type="button"
      @click.stop="refilter"
    >
      <slot />
    </button>
  </BLayout>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { useFilterService } from '@/composable/user/leadList/filter-service';

export default {
  name: 'DuplicateStateButton',
  props: {
    duplicateKey: {
      type: String,
      required: true,
    },
    duplicateValue: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { setFilterAndMoveLeadList } = useFilterService();
    return {
      setFilterAndMoveLeadList,
    };
  },
  methods: {
    ...mapWaitingActions('userUi', {
      setLeadListSortKeyAction: 'setLeadListSortKeyAction',
      setLeadListSortOrderAction: 'setLeadListSortOrderAction',
      setLeadListSelectedColumnsAction: 'setLeadListSelectedColumnsAction',
    }),
    refilter() {

      this.setLeadListSortKeyAction('callTargetCreatedAt');
      this.setLeadListSortOrderAction('asc');
      this.setLeadListSelectedColumnsAction([
        'companyName',
        'targetName',
        'email',
        'isEmailDuplicated',
        'lastActivityAt',
        'lastActivityTypeText',
        'lastActivityComment',
        'nextActions',
        'callTargetCreatedAt',
        'operatorName',
      ]);

      const filterParams = {};
      filterParams[this.duplicateKey] = { inc: { or: this.duplicateValue } };
      this.setFilterAndMoveLeadList(filterParams);
    },
  },
};
</script>

<style lang="scss" scoped>
  button {
    background-color: $mars;
    border-radius: 14px;
    height: 28px;
    width: 84px;
    color: $textcolor-white;
  }

  button:hover {
    opacity: 0.7;
  }
</style>
